export default '/static/frontend/ReachDigital/12gobiking/dist/assets/iban-fr-0ceedd28.png'